import Box from '@passkeys/ui/box';
import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames';
import type { SwapFormVariant } from '../types.js';

type FormLayoutProps = {
  variant: SwapFormVariant;
  children: ReactNode;
};

function FormLayout({ variant, children }: FormLayoutProps) {
  const isHorizontal = variant === 'horizontal';
  const isVertical = variant === 'vertical';

  return (
    <Box
      className={cn(
        'grid w-full gap-y-2 pb-6 pt-4',
        isHorizontal && 'grid-cols-[1fr_auto_1fr] grid-rows-[auto_auto]',
        isVertical && 'grid-cols-2 grid-rows-[repeat(auto)]',
      )}
    >
      {children}
    </Box>
  );
}

export default FormLayout;
